import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=ba5c0d64&scoped=true&"
import script from "./IconArrow.vue?vue&type=script&lang=js&"
export * from "./IconArrow.vue?vue&type=script&lang=js&"
import style0 from "./IconArrow.vue?vue&type=style&index=0&id=ba5c0d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c0d64",
  null
  
)

export default component.exports